import { useLang } from "@/context/LanguageContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSelector({ compact = false }) {
  const { lang, setLang, languages } = useLang();
  const current = languages.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector"
          className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card/70 px-3 py-1.5 text-sm font-medium text-foreground/80 hover:bg-card transition-colors"
        >
          <Globe className="h-4 w-4" />
          {current?.label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem] rounded-2xl">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`rounded-xl cursor-pointer ${l.code === lang ? "bg-secondary font-semibold" : ""}`}
          >
            <span className="mr-2 text-xs text-muted-foreground">{l.label}</span>
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
